export default {
    appVer: 'v1.1.13',
    gaKey: 'UA-12737366-3',
};



// WEBPACK FOOTER //
// ./src/config/prod.js